import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    color: 'bg-emerald-500',
    lightColor: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    textColor: 'text-emerald-700',
    emoji: '🟢',
    title: 'Fundamentos de la Energía Nuclear',
    subtitle: 'Todo lo que necesitás saber antes de entrar al aula',
    desc: 'Historia de la física nuclear desde Becquerel hasta el CAREM-25, estructura del átomo y modelos atómicos, E=mc² y la equivalencia masa-energía, fisión y fusión nuclear, tipos de radiación (alfa, beta, gamma), radiactividad natural y artificial, la historia del programa nuclear argentino desde 1950.'
  }, {
    id: 2,
    color: 'bg-blue-400',
    lightColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    textColor: 'text-blue-700',
    emoji: '🔵',
    title: 'Física Nuclear y Radiactividad',
    subtitle: 'Conocé la física del núcleo con profundidad',
    desc: 'Isótopos, carta nuclear, números mágicos, ley del decaimiento radiactivo, vida media, datación por C-14, series radiactivas, detección de radiación, el sistema completo de unidades de dosis. Todo con ejercicios resueltos con datos reales.'
  }, {
    id: 3,
    color: 'bg-yellow-500',
    lightColor: 'bg-yellow-50',
    borderColor: 'border-yellow-200',
    textColor: 'text-yellow-700',
    emoji: '🟡',
    title: 'Reactores Nucleares y Producción de Energía',
    subtitle: 'Argentina genera el 8-10% de su electricidad',
    desc: 'Funcionamiento del reactor nuclear, los 7 componentes esenciales, los tres circuitos, tipos de reactores (PWR, BWR, PHWR/CANDU, SMR), el combustible nuclear, moderadores y refrigerantes, barras de control y SCRAM, el ciclo completo del combustible en Argentina.'
  }, {
    id: 4,
    color: 'bg-purple-500',
    lightColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
    textColor: 'text-purple-700',
    emoji: '🟣',
    title: 'Seguridad Nuclear y Protección Radiológica',
    subtitle: 'Intérprete riguroso de los accidentes nucleares',
    desc: 'Principios de seguridad nuclear (Defensa en Profundidad, ALARA), protección radiológica, las cuatro barreras de contención, la Escala INES, Three Mile Island (1979), Chernóbil (1986) y Fukushima (2011) analizados con datos verificados de la OMS y UNSCEAR.'
  }, {
    id: 5,
    color: 'bg-sky-500',
    lightColor: 'bg-sky-50',
    borderColor: 'border-sky-200',
    textColor: 'text-sky-700',
    emoji: '⭐',
    title: 'Aplicaciones de la Energía Nuclear',
    subtitle: 'Impacto real en la vida cotidiana',
    desc: 'Medicina nuclear (SPECT, PET, Tc-99m producido en Ezeiza), radioterapia, producción de radioisótopos en el RA-3 para toda Latinoamérica, gammagrafía industrial en gasoductos argentinos, Técnica del Insecto Estéril en los viñedos de Mendoza.'
  }, {
    id: 6,
    color: 'bg-emerald-400',
    lightColor: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    textColor: 'text-emerald-700',
    emoji: '🟢',
    title: 'Energía Nuclear en Argentina y el Mundo',
    subtitle: 'Perspectiva ciudadana real',
    desc: '75 años de historia nuclear argentina (CNEA, Instituto Balseiro, INVAP), las tres centrales argentinas en detalle, el CAREM-25 como el primer SMR del mundo en construcción avanzada, el panorama mundial nuclear en 2026, los países líderes, la fusión nuclear.'
  }];
  return <section className="py-20 bg-surface" data-id="element-317">
      <div className="container mx-auto px-4" data-id="element-318">
        <div className="text-center mb-16" data-id="element-319">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-electric/20 text-electric border border-electric/30 font-bold mb-6" data-id="element-320">
            ☢️ LOS 6 TOMOS
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-321">
            Un tomo por cada dimensión de la Energía Nuclear Argentina
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-322">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`rounded-2xl border border-surface bg-base/60 overflow-hidden shadow-lg hover:shadow-xl hover:border-electric/50 transition-all flex flex-col h-full`} data-id="element-323">
              <div className={`bg-base/80 p-4 border-b border-surface flex items-center gap-3`} data-id="element-324">
                <div className="text-2xl" data-id="element-325">{tomo.emoji}</div>
                <div data-id="element-326">
                  <p className={`text-xs font-bold uppercase tracking-wider text-muted`} data-id="element-327">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-328">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-329">
                <p className="font-semibold text-muted mb-3 pb-3 border-b border-surface" data-id="element-330">
                  {tomo.subtitle}
                </p>
                <p className="text-muted text-sm leading-relaxed" data-id="element-331">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}